import { useParams } from 'react-router-dom';

interface RouteParams {
  id: string;
}

const useParamId = (): number => {
  const routeParams = useParams<RouteParams>();
  return parseInt(routeParams.id);
};

export { useParamId };
